import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import CustomDropdown from "../../component/CustomDropdown";
import Header from "../../component/Header";
import Avatar from "../../component/NumberOptions/Avatar";
import numberOptions from "../../component/NumberOptions/numberOptionsdata";
import Pagination from "../../component/Pagination";
import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
import IconDots from "../../component/SvgIcons/IconDotes";
import IconEdit from "../../component/SvgIcons/IconEdit";
import IconFilter from "../../component/SvgIcons/IconFilter";
import IconPlus from "../../component/SvgIcons/IconPlus";
import IconSearchTable from "../../component/SvgIcons/IconSearchTable";
import IconView from "../../component/SvgIcons/IconView";
import api from "../../services/axios";
import useBootstrapTooltip from "../../services/useBootstrapTooltip";
import utils from '../../utils/utils';

export default function CustomersList() {
  const [selectedRows, setSelectedRows] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const dropdownRefs = useRef({});
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const [itemsPerPage, setItemsPerPage] = useState(
    window.innerWidth >= 1920 ? 20 : 10
  );
  const [rowData, setRowData] = useState([]);
  const selectAllRef = useRef();
  const [sortField, setSortField] = useState("Customer_Name");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500); // 500ms debounce

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);


  useEffect(() => {
    utils.saveRecentSearch('Customer List', window.location.pathname)
  }, [])

  // Adjust visible columns dynamically
  useEffect(() => {
    if (!selectAllRef.current) return;

    const pageRowIds = rowData.map((row) => row.Code);
    const selectedCount = pageRowIds.filter((id) =>
      selectedRows.includes(id)
    ).length;

    selectAllRef.current.indeterminate =
      selectedCount > 0 && selectedCount < pageRowIds.length;
  }, [selectedRows, rowData, currentPage]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      let isOutside = true;
      // ✅ Check if the click happened inside any dropdown
      Object.values(dropdownRefs.current).forEach((ref) => {
        if (ref && ref.contains(event.target)) {
          isOutside = false;
        }
      });
      if (isOutside) {
        // ✅ Close the dropdown when clicking outside
        setOpenDropdown(null);
      }
    };
    // ✅ Use "mousedown" instead of "click" for better responsiveness
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const [totalPages , setTotalPages] = useState();
  useEffect(() => {
    const fetchCustomers = async () => {
      setLoading(true);
      try {
        let obj = {limit : itemsPerPage , page : currentPage , search : debouncedSearch}
        const res = await api.post("/GetCustomerList" , obj);
        console.log("Customers data:", res.data.data);
        setTotalPages(res.data.totalPages);
        if (res.data.data && Array.isArray(res.data.data)) {
          setRowData(res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch agents:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomers();
  } , [itemsPerPage , currentPage , debouncedSearch])



  // useEffect(() => {
  //   const fetchCustomers = async () => {
  //     setLoading(true);
  //     try {
  //       const res = await api.post("/list_customer");
  //       console.log("Customers data:", res.data.data);        
  //       if (res.data.data && Array.isArray(res.data.data)) {
  //         setRowData(res.data.data);
  //       } 
  //     } catch (error) {
  //       console.error("Failed to fetch agents:", error);
  //     }finally {
  //     setLoading(false);
  //   }
  //   };

  //   fetchCustomers();
  // }, []);

  // ✅ Handle row selection
  const handleRowSelect = (rowId) => {
    if (selectedRows.includes(rowId)) {
      setSelectedRows(selectedRows.filter((id) => id !== rowId));
    } else {
      setSelectedRows([...selectedRows, rowId]);
    }
  };

  // ✅ Handle "Select All"
  const handleSelectAll = () => {
    const pageRowIds = rowData.map((row) => row.Code);
    const allSelected = pageRowIds.every((id) => selectedRows.includes(id));
    if (allSelected) {
      setSelectedRows((prev) => prev.filter((id) => !pageRowIds.includes(id)));
    } else {
      setSelectedRows((prev) => [...new Set([...prev, ...pageRowIds])]);
    }
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };
  // ✅ Handle Search
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleDropdownToggle = (rowId, event) => {
    event.stopPropagation();
    setOpenDropdown((prev) => (prev === rowId ? null : rowId));
  };

  const handleOptionClick = () => {
    setOpenDropdown(null);
  };

  // ✅ Filtered and sorted data
  // const filteredData = rowData
  //   .filter((row) =>
  //     Object.values(row).some((value) => {
  //       if (value == null) return false; // skip null/undefined
  //       const stringValue = value.toString().toLowerCase();
  //       return stringValue.includes(searchQuery.toLowerCase());
  //     })
  //   )
  //   .sort((a, b) => {
  //     const aValue = a[sortField] ?? "";
  //     const bValue = b[sortField] ?? "";

  //     if (typeof aValue === "string" && typeof bValue === "string") {
  //       return sortOrder === "asc"
  //         ? aValue.localeCompare(bValue)
  //         : bValue.localeCompare(aValue);
  //     }

  //     // Handle numbers or fallback
  //     return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
  //   });
    

  useBootstrapTooltip([rowData, currentPage]);
  const handlePageChange = (page) => setCurrentPage(page);

  return (
    <div className="dashboard">
      <Header title subtitle="Customers List" />

      <div className="center-content">
        <div className="container">
          <AnimatePresence mode="wait">
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
            >
              <div className="pagegap d-flex flex-column">
                <h2 className="create-titles mb-0 d-flex align-items-center">
                  <DiamondsFour /> <span>Customers</span>
                </h2>
                <div className="tabletopbar d-flex align-items-center gap-2 justify-content-between flex-column flex-md-row">
                  <div className="tablefilter d-flex align-items-center">
                    <Link to="/create-customer" className="btn btngradiant">
                      <IconPlus /> Add Customer
                    </Link>


                    <div
                      className={`selacteditems d-flex align-items-center ${selectedRows.length > 0 ? "selectedvalue" : ""
                        }`}
                    >
                      <span>{selectedRows.length} Selected</span>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3">
                    <div className="tablesearch position-relative">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={handleSearch}
                      />
                      <span className="position-absolute">
                        <IconSearchTable />
                      </span>
                    </div>

                    <CustomDropdown
                      name="itemsPerPage"
                      options={numberOptions}
                      value={itemsPerPage.toString()}
                      onChange={(value) => {
                        const num = Number(value);
                        setItemsPerPage(num);
                        setCurrentPage(1);
                      }}
                      placeholder="Items Per Page"
                      className="items-per-page-dropdown"
                    />
                  </div>
                </div>
                <div className="tablespace">
                  <div className="table-responsive" ref={tableRef}>
                    <table className="table table-hover my-0">
                      <thead className="thead-light">
                        <tr>
                          <th>
                            <div className="d-flex align-items-center gap-1">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="selectAllCheckbox"
                                ref={selectAllRef}
                                onChange={handleSelectAll}
                                checked={
                                  rowData.length > 0 &&
                                  rowData.every((row) =>
                                    selectedRows.includes(row.Code)
                                  )
                                }
                              />

                              <label
                                className="tablecheckbox headercheckbox position-relative"
                                htmlFor="selectAllCheckbox"
                              >
                                &nbsp;
                              </label>

                              <div className="d-flex align-items-center justify-content-between w-100">
                                <span>Customer Name</span>

                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSort("Customer_Name")}
                                >
                                  <IconFilter />
                                </span>
                              </div>
                            </div>
                          </th>


                          <th>
                            <div className="d-flex align-items-center justify-content-between">
                              Code
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("Code")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>

                          <th>
                            <div className="d-flex align-items-center justify-content-between">
                              Location
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("Location")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="d-flex align-items-center justify-content-between">
                              City
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("City")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>

                          <th>
                            <div className="d-flex align-items-center justify-content-between">
                              State
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("State")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>

                          <th>
                            <div className="d-flex align-items-center justify-content-between">
                              Email
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("Contact_Email_Id")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>

                          <th>
                            <div className="d-flex align-items-center justify-content-between">
                              Address
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("Address")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>

                          <th>
                            <div className="d-flex align-items-center justify-content-between">
                              Contact Person
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("Contact_Person")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>

                          <th>
                            <div className="d-flex align-items-center justify-content-between">
                              Mobile Number
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleSort("Contact_Mobile_No")
                                }
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="d-flex align-items-center justify-content-between">
                              Customer Type
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("Customer_Type")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>

                          <th>
                            <div className="d-flex align-items-center justify-content-between">
                              Date
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleSort("Create_Date_Time_Stamp")
                                }
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>


                          <th
                            width="1"
                            style={{ padding: 0, width: "1px" }}
                          ></th>
                        </tr>
                      </thead>

                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="11" className="text-center" style={{ padding: "30px" }}>
                              Loading, please wait...
                            </td>
                          </tr>
                        ) : rowData.length > 0 ? (
                          rowData.map((row, index) => (
                            <tr
                              style={{ cursor: "pointer" }}
                              key={row.Code}
                              className={
                                selectedRows.includes(row.Code)
                                  ? "selected-row"
                                  : ""
                              }
                              onClick={() => {
                                navigate(`/customer-dashboard/${row.Code}`)
                                window.scrollTo(0, 0);
                              }}
                            >
                              <td>
                                <figure
                                  className="d-flex align-items-center custom-control-label"
                                  style={{ cursor: "pointer" }}
                                >
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id={`customCheckDisabled-${row.Code}`}
                                    checked={selectedRows.includes(row.Code)}
                                    onChange={() => handleRowSelect(row.Code)}
                                  />
                                  <label
                                    className="tablecheckbox customerstable position-relative d-flex align-items-center gap-2"
                                    htmlFor={`customCheckDisabled-${row.Code}`}
                                  >
                                    <Avatar
                                      name={row.Customer_Name}
                                      index={index}
                                      width={20}
                                      height={20}
                                      fontSize={10}
                                    />

                                    {row.Customer_Name}
                                  </label>
                                </figure>
                              </td>


                              <td>{row.Code}</td>

                              <td>{row.Location}</td>

                              <td>{row.City}</td>

                              <td>{row.State}</td>

                              <td>{row.Contact_Email_Id}</td>

                              <td data-bs-toggle="tooltip" data-bs-placement="top" title={row.Address}>
                                {row.Address?.split(" ").slice(0, 6).join(" ") +
                                  (row.Address?.split(" ").length > 6 ? "..." : "")}
                              </td>

                              <td>{row.Contact_Person}</td>

                              <td>{row.Contact_Mobile_No}</td>

                              <td>{row.Customer_Type}</td>

                              <td>
                                {row.Create_Date_Time_Stamp &&
                                  row.Create_Date_Time_Stamp !==
                                  "0000-00-00 00:00:00"
                                  ? (() => {
                                    const date = new Date(
                                      row.Create_Date_Time_Stamp
                                    );
                                    if (isNaN(date)) return ""; // invalid date fallback
                                    const day = String(
                                      date.getDate()
                                    ).padStart(2, "0");
                                    const month = String(
                                      date.getMonth() + 1
                                    ).padStart(2, "0");
                                    const year = date.getFullYear();
                                    return `${day}-${month}-${year}`;
                                  })()
                                  : ""}
                              </td>


                              <td
                                align="right"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div
                                  className={`actions-wrapper ${openDropdown === row.Code ? "open" : ""
                                    }`}
                                  ref={(el) =>
                                    (dropdownRefs.current[row.Code] = el)
                                  }
                                >
                                  <div
                                    className="tranparenteffect position-relative"
                                    onClick={(e) =>
                                      handleDropdownToggle(row.Code, e)
                                    }
                                  >
                                    <IconDots />
                                  </div>
                                  <div className="action-options">
                                    <Link
                                      to={`/edit-customer-details/${row.Code}`}
                                      onClick={handleOptionClick}
                                    >
                                      <IconEdit /> Edit
                                    </Link>
                                    <Link
                                      to={`/customer-dashboard/${row.Code}`}
                                      onClick={handleOptionClick}
                                    >
                                      <IconView /> View
                                    </Link>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="11" className="text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {totalPages > 0 && (
                    <Pagination
                      totalPages={totalPages}
                      currentPage={currentPage}
                      handlePageChange={handlePageChange}
                    />
                  )}
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
